module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-1",
    attrs: {
      "id": "untitled-1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "untitled-11"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal-222-0-override"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "normal-222-0-override"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "normal-222-0-override"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("For Barb.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-222-0-override"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("All my love,")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-222-0-override"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("all my life.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_4"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46900f7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0000_split_002.vue
// module id = 66
// module chunks = 0